export function buildOrderedItemMap(orders) {
  const map = {};

  orders
    .filter((order) => order?.status !== 'CANCELLED')
    .forEach((order) => {
      (order?.items || []).forEach((item) => {
        const menuId = item?.daily_menu_id;
        if (menuId == null || Number(item?.quantity) <= 0) return;
        map[menuId] = (map[menuId] || 0) + Number(item.quantity);
      });
    });

  return map;
}

export function buildIssuedItemMap(orders) {
  const map = {};

  orders
    .filter((order) => order?.status === 'DELIVERY' || order?.status === 'DELIVERED')
    .forEach((order) => {
      (order?.items || []).forEach((item) => {
        const menuId = item?.daily_menu_id;
        if (menuId == null || Number(item?.quantity) <= 0) return;
        map[menuId] = (map[menuId] || 0) + Number(item.quantity);
      });
    });

  return map;
}
